export const GET_INHERITED_RIPPLE_INFO = `
query getRippleInfo(
    $orgId: String!
    $rippleId: String!
    $canViewOnlyOwn: Boolean!
  ) {
    viewer {
      organizationScope(id: $orgId) {
        inheritedRipple(id: $rippleId, onlyMine: $canViewOnlyOwn) {
          id
          languageCode
          rippleImage {
            id
            thumbnailUrl
          }
          createdAt
          createdBy {
            id
            name
          }
          dayOfTheWeek
          timeOfTheDay
          isApproved
          approvedBy {
            id
            name
          }
          isTemplate
          isShareable
          isFrame
          tags
        }
      }
    }
  }
`;
